import { initializeApp } from "firebase/app"
import { getFirestore, doc, getDoc } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyA2Vk0UfnEtC9WnvIfQ1KIPI71wPsdVNKI",
  authDomain: "phonics-pk.firebaseapp.com",
  projectId: "phonics-pk",
  storageBucket: "phonics-pk.firebasestorage.app",
  messagingSenderId: "40930226533",
  appId: "1:40930226533:web:4b2e164e86bca38e35f18c"
}

const app = initializeApp(firebaseConfig)

export const db = getFirestore(app)